import React, { useContext, useEffect } from "react";
import SolutionFirst from "./SolutionFirst";
import SolutionSecond from "./SolutionSecond";
import { MenuContext } from "../../App";

function Solutions() {
  const [isMenuClicked, setIsMenuClicked] = useContext(MenuContext);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    setIsMenuClicked(!isMenuClicked);
  }, []);
  return (
    <div className="w-full flex flex-col gap-y-10">
      <SolutionFirst />
      <SolutionSecond />
    </div>
  );
}

export default Solutions;
